import { render, staticRenderFns } from "./DeletePlate.vue?vue&type=template&id=d83aadc6"
import script from "./DeletePlate.vue?vue&type=script&lang=js"
export * from "./DeletePlate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports